import { render } from "./AsFooter.vue?vue&type=template&id=3a09fbfe&ts=true"
import script from "./AsFooter.vue?vue&type=script&lang=ts"
export * from "./AsFooter.vue?vue&type=script&lang=ts"

import "./AsFooter.vue?vue&type=style&index=0&id=3a09fbfe&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__